<template>
  <div class="header-container">
    <!-- mobile header -->
    <div class="flex lg:hidden items-center justify-between w-full px-[25px] h-[64px]">
      <!-- Логотип + registered -->
      <div class="flex items-center h-full">
        <!-- Logo -->
        <div class="h-full flex items-center">
          <img :src="localImageUrl" alt="Chesla logo" class="h-[20px] sm:h-[22px] object-contain"/>
        </div>
        <!-- Registered -->
        <div class="flex items-center -ml-1 -mt-2">
          <img :src="registered" alt="Registered" class="h-[9px] object-contain"/>
        </div>
      </div>

    <button
    @click="toggleMobileMenu"
    class="text-2xl h-full flex items-center focus:outline-none">
    ☰
    </button>
    </div>
    <!-- Mobile line -->
    <div class="lg:hidden w-full border-b border-gray-300 -mt-[2px]"></div>

    <!-- dekstop logo -->
    <div class="hidden lg:flex items-center justify-start ml-[5%] mt-[3%] lg:ml-2 lg:mt-2">
      <div class="w-7rem h-2rem flex items-center justify-center pt-1 lg:-mt-2">
        <img :src="localImageUrl" alt="Chesla logo" class="object-contain" />
      </div>
      <div class="w-4rem h-2rem mt-1">
        <img :src="registered" alt="Registered" class="w-3 h-4 object-contain" />
      </div>
    </div>

    <!-- desktop menu -->
    <div class="hidden lg:flex justify-end lg:ml lg:justify-start items-start w-full">
      <Menubar :model="menuItems" class="flex no-border-menubar lg:-mt-2 lg:ml-[3%]"/>
    </div>

    <!-- mobile sidebar -->
    <div class="lg:hidden">

      <!-- Overlay -->
      <div
        class="overlay" :class="{ 'overlay-active': mobileMenuOpen }"
        @click="mobileMenuOpen = false">
      </div>

      <!-- Sidebar -->
      <transition name="slide-right">
        <div v-if="mobileMenuOpen" class="sidebar-menu">
          <!-- Top -->
          <div class="flex justify-between items-center h-16 px-4 border-b border-gray-300">
            <img :src="localImageUrl" alt="Logo" class="h-8 object-contain" />
           
            <button
            @click="mobileMenuOpen = false"
            class="close-btn"
            aria-label="Close menu">
            <svg xmlns="http://www.w3.org/2000/svg"
                class="w-7 h-7 stroke-[1.8]"
                fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        
          <!-- Menu items -->
          <ul class="flex flex-col gap-1.5 p-4 -mt-1">
            <li v-for="(item, index) in menuItems" :key="index">
              <a
                @click="navigate(item)"
                class="block py-2 px-2 text-lg font-medium hover:bg-gray-100 cursor-pointer text-left"
              >
                <i :class="item.icon" class="mr-2"></i>
                {{ item.label }}
              </a>
            </li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>


<script>
import router from '@/router';
import logoUrl from '@/assets/logo/chesla-logo.png';
import registeredLogo from '@/assets/logo/registered-logo.png';

export default {
  name: 'HeaderComponent',

  data() {
    return {
      localImageUrl: logoUrl,
      registered: registeredLogo,
      mobileMenuOpen: false,

      // menu
      menuItems: [
        {
          label: 'О компании',
          icon: 'pi pi-home',
          route: '/about',
          command: () => router.push('/about')
        },
        {
          label: 'Решения',
          icon: 'pi pi-server',
          route: '/solution',
          command: () => router.push('/solution')
        },
        {
          label: 'Услуги',
          icon: 'pi pi-box',
          route: '/work',
          command: () => router.push('/work')
        },
        {
          label: 'Проекты',
          icon: 'pi pi-briefcase',
          route: '/project',
          command: () => router.push('/project')
        },
        {
          label: 'Отзывы',
          icon: 'pi pi-receipt',
          route: '/feedback',
          command: () => router.push('/feedback')
        },
        {
          label: 'Партнеры',
          icon: 'pi pi-id-card',
          route: '/partner',
          command: () => router.push('/partner')
        },
        {
          label: 'Публикации',
          icon: 'pi pi-volume-down',
          route: '/publish',
          command: () => router.push('/publish')
        },
        {
          label: 'Новости',
          icon: 'pi pi-globe',
          route: '/news',
          command: () => router.push('/news')
        },
        {
          label: 'Контакты',
          icon: 'pi pi-address-book',
          route: '/contact',
          command: () => router.push('/contact')
        },
      ],
    };
  },


  watch: {
    mobileMenuOpen(val) {
      document.body.style.overflow = val ? 'hidden' : '';
    }
  },

  methods: {

    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },

    // Mobile navigation
    navigate(item) {
      router.push(item.route);
      this.mobileMenuOpen = false;
    },

  },
};
</script>

<style>
.no-border-menubar {
  border: none !important;
}

/* Overlay */
.overlay {
  position: fixed;
  inset: 0;
  z-index: 40;
  background-color: rgba(0,0,0,0.5);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.4s ease-in-out;
}

.overlay-active {
  opacity: 1;
  pointer-events: auto;
}

/* Sidebar */
.sidebar-menu {
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 80%;
  max-width: 400px;
  background: white;
  z-index: 50;
  box-shadow: 0 0 15px rgba(0,0,0,0.2);
  display: flex;
  flex-direction: column;
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
  overflow: hidden; /* оставляем для контейнера */
}

/* Новый стиль для скролла меню */
.sidebar-menu ul {
  flex-grow: 1; /* чтобы занять все доступное пространство */
  overflow-y: auto; /* вертикальная прокрутка */
  padding: 1rem; /* можно настроить */
}

/* Animation */
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.3s ease;
}

.slide-right-enter-from,
.slide-right-leave-to {
  transform: translateX(100%);
}

.slide-right-enter-to,
.slide-right-leave-from {
  transform: translateX(0);
}

.close-btn {
  position: absolute;
  top: 0.5rem;           
  right: 0.7rem;
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 60;         
  background: transparent;
  border: none;
  cursor: pointer;
}
</style>